import React, { useState } from "react"
import { Link } from "wouter"
import { recover } from "../services/api"
import { recuperaPassword, changePassword } from "../services/api_dipendenti"
import { XCircleIcon } from "@heroicons/react/24/outline"
import Toggle from "../components/toggle"

export default function Recover() {

  const email = React.useRef(null)
  const codiceAzienda = React.useRef(null)
  const [success, setSuccess] = React.useState(false)
  const [successEmployeeCode, setSuccessEmployeeCode] = React.useState(false);
  const [successRecoverEmployee, setSuccessRecoverEmployee] = React.useState(false);
  const [error, setError] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [selectedOption, setSelectedOption] = React.useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState(''); 

  const handleToggleChange = (option) => {
    setSelectedOption(option);
  };

  const handleInputChange = () => {
    setError('');
  };

  // recupera psw azienda
  const formSubmisison = (e) => {
    setLoading(true)
    e.preventDefault()
    if(!email.current?.value || !codiceAzienda.current?.value) {
      setError('Email e codice azienda sono obbligatori');
      setLoading(false);
      return;
    }
    // setToken('eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxMzE2MjM5MDIyLCJleHAiOjE5MTYyMzkwMjIsImNvbXBhbnlfaWQiOjIyNjN9.39fiXNuHNMjhclMTGyONy_bpVejgtGWCbWMC4p9SN10')
    recover({
      email: email.current.value,
      codice_azienda: codiceAzienda.current.value
    }).then((res) => {
      setSuccess(true)
      setLoading(false)
    }).catch((err) => {
      console.log(err.response.data.error)
      setError(err.response.data.error)
      setSuccess(false)
      setLoading(false)
    })
  }

  //recupera psw dipendente
  const formSubmissionEmployee = (e) => {
    setLoading(true)
    e.preventDefault()
    if(!email.current?.value || !codiceAzienda.current?.value) {
      setError('Email e codice azienda sono obbligatori');
      setLoading(false);
      return;
    }
    recuperaPassword({
      email: email.current.value,
      codice_azienda: codiceAzienda.current.value
    }).then((res) => {
      setSuccessEmployeeCode(true)
      setLoading(false)
    }).catch((err) => {
      console.log(err.response.data.error)
      setError(err.response.data.error)
      setSuccessEmployeeCode(false)
      setLoading(false)
    })
  }

  const handleVerificationSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (newPassword !== confirmPassword) {
      setError('Le password non corrispondono');
      setLoading(false);
      return;
    }
    try {
      await changePassword({
        email: email.current.value,
        codice_azienda: codiceAzienda.current.value,
        codice: verificationCode,
        password: newPassword
      });
      setSuccessRecoverEmployee(true);
      setSuccessEmployeeCode(false); 
    } catch (err) {
      setError(err.response?.data?.message || 'Errore sconosciuto');
    } finally {
      setLoading(false);
    }
  };


  const handleSubmit = (e) => {
    if (selectedOption === 'Dipendente') {
      formSubmissionEmployee(e);
    } else {
      formSubmisison(e);
    }
  }

  return (
    <>
      <div className="flex min-h-full flex-col justify-center py-12 sm:px-6 lg:px-8" id="main_bg" style={{ minHeight: '100vh' }}>
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-white">Recupera accesso all'area riservata</h2>
          <h3 className="mt-6 text-center text-xl font-bold tracking-tight text-white">Seleziona la tipologia di Utente</h3>
          <div className='justify-center flex mt-4'>
            <Toggle
              color="indigo"
              gradeBgColor="600"
              optionLeft="Dipendente"
              optionRight="Azienda"
              selectedOption={selectedOption}
              onChange={handleToggleChange}
              disabled={selectedOption !== ''}
            />
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4 mt-4">
              <div className="flex">
                <div className="flex-shrink-0">
                  <XCircleIcon className="h-5 w-5 text-red-400" />
                </div>
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800">Si è verificato un errore</h3>
                  <div className="mt-2 text-sm text-red-700">
                    <ul role="list" className="list-disc space-y-1 pl-5">
                      <li>{error}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {!loading && successRecoverEmployee && (
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <div className="text-sm">
                <Link
                  to="/"
                  className="font-medium text-indigo-600 hover:text-indigo-500">
                  Torna al login
                </Link>
              </div>
            </div>
          </div>
        )}


        {!loading && success && (
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <h1>Controlla la tua email</h1>
              <div className="text-sm">
                <Link
                  to="/"
                  className="font-medium text-indigo-600 hover:text-indigo-500">
                  Torna al login
                </Link>
              </div>
            </div>
          </div>
        )}

        {!loading && successEmployeeCode && (
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <form className="space-y-6" onSubmit={handleVerificationSubmit}>
                <div>
                  <label htmlFor="verificationCode" className="block text-sm font-medium leading-6 text-gray-900">
                    Codice di Verifica
                  </label>
                  <p className="text-xs">Inserisci il codice di verifica ricevuto sulla mail e crea una nuova password</p>
                  <div className="mt-2">
                    <input
                      id="verificationCode"
                      name="verificationCode"
                      type="text"
                      value={verificationCode}
                      onChange={(e) => { setVerificationCode(e.target.value); handleInputChange(); }}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                    Email
                  </label>
                  <div className="mt-2">
                    <input
                      ref={email}
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      onChange={handleInputChange}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="codiceAzienda" className="block text-sm font-medium leading-6 text-gray-900">
                    Codice Azienda
                  </label>
                  <div className="mt-2">
                    <input
                      ref={codiceAzienda}
                      id="codiceAzienda"
                      name="codice"
                      type="text"
                      autoComplete="codiceAzienda"
                      onChange={handleInputChange}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="newPassword" className="block text-sm font-medium leading-6 text-gray-900">
                    Nuova Password
                  </label>
                  <div className="mt-2">
                    <input
                      id="newPassword"
                      name="newPassword"
                      type="password"
                      value={newPassword}
                      onChange={(e) => { setNewPassword(e.target.value); handleInputChange(); }}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="confirmPassword" className="block text-sm font-medium leading-6 text-gray-900">
                    Conferma Nuova Password
                  </label>
                  <div className="mt-2">
                    <input
                      id="confirmPassword"
                      name="confirmPassword"
                      type="password"
                      value={confirmPassword}
                      onChange={(e) => { setConfirmPassword(e.target.value); handleInputChange(); }}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {!loading && selectedOption && !success && !successEmployeeCode && !successRecoverEmployee && (
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div className="bg-white px-4 py-8 shadow sm:rounded-lg sm:px-10">
              <form className="space-y-6" onSubmit={handleSubmit}>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                    Email
                  </label>
                  <div className="mt-2">
                    <input
                      ref={email}
                      id="email"
                      name="email"
                      type="email"
                      autoComplete="email"
                      onChange={handleInputChange}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="codiceAzienda" className="block text-sm font-medium leading-6 text-gray-900">
                    Codice Azienda
                  </label>
                  <div className="mt-2">
                    <input
                      ref={codiceAzienda}
                      id="codiceAzienda"
                      name="codice"
                      type="text"
                      autoComplete="codiceAzienda"
                      onChange={handleInputChange}
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    />
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                  >
                    Recupera
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {loading && (
          <div className="text-center">
            <div role="status">
              <svg className="inline w-10 h-10 mr-2 text-gray-200 animate-spin dark:text-grey-100 fill-purple-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
